import React from 'react';
import { Col, Form, Row, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';

const CheckboxesSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6} />
      <Col span={6}>
        <Form.Item
          label={t('Fino esaurimento scorte')}
          name='until_last'
          valuePropName={'checked'}
        >
          <Checkbox disabled={isView} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          label={t('Solo per dipendenti')}
          name='staff_only'
          valuePropName={'checked'}
        >
          <Checkbox disabled={isView} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(CheckboxesSection);
